import {TOGGLE_MENU, TOGGLE_FLOATING_MENU, CONTENT_ROUTE} from '../actions'

const initialState = {
    open: false,
    floatingMenuOpen: false
}

const menu = (state = initialState, action) => {
    switch (action.type) {
        case TOGGLE_MENU:
            return {
                ...state,
                open: !state.open,
                floatingMenuOpen: false
            }
        case TOGGLE_FLOATING_MENU:
            return {
                ...state,
                floatingMenuOpen: !state.floatingMenuOpen,
                open: false,
            }
        case CONTENT_ROUTE:
            return {
                ...state,
                open: false,
                floatingMenuOpen: false,
            }
        default:
            return state
    }
}

export default menu



// WEBPACK FOOTER //
// ./src/reducers/menu.js